/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudPairingDeviceCodeVlrOrgSecretSpec } from './cloudPairingDeviceCodeVlrOrgSecretSpec';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { VlrOrgSecretsUpsertSpecDeployment } from './vlrOrgSecretsUpsertSpecDeployment';
import { CloudPairingClientSecretVlrOrgSecretSpec } from './cloudPairingClientSecretVlrOrgSecretSpec';
import { CarbonBlackVlrOrgSecretSpec } from './carbonBlackVlrOrgSecretSpec';
import { VlcrVlrOrgSecretSpec } from './vlcrVlrOrgSecretSpec';
import { VmcfsSddcVmcVlrOrgSecretSpec } from './vmcfsSddcVmcVlrOrgSecretSpec';
import { CrowdstrikeVlrOrgSecretSpec } from './crowdstrikeVlrOrgSecretSpec';
import { SddcVmcVlrOrgSecretSpec } from './sddcVmcVlrOrgSecretSpec';
import { SecretManagerAccount } from './secretManagerAccount';


export interface VlrOrgSecretsUpsertSpec { 
    carbon_black?: CarbonBlackVlrOrgSecretSpec;
    cloud_account_type: SecretManagerAccount;
    cloud_pairing_client_secret?: CloudPairingClientSecretVlrOrgSecretSpec;
    cloud_pairing_device_code?: CloudPairingDeviceCodeVlrOrgSecretSpec;
    cloud_provider: CloudProvidersEnum;
    crowdstrike?: CrowdstrikeVlrOrgSecretSpec;
    deployment?: VlrOrgSecretsUpsertSpecDeployment;
    sddc_vmc?: SddcVmcVlrOrgSecretSpec;
    vlcr?: VlcrVlrOrgSecretSpec;
    vlr_org_id: string;
    vmcfs_sddc_vmc?: VmcfsSddcVmcVlrOrgSecretSpec;
}
export namespace VlrOrgSecretsUpsertSpec {
}


